
export const GET_CARGUES = "GET_CARGUES";
export const GET_STATE_LOADING = "GET_STATE_LOADING";